var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.environment != 'Production')?_c('dev-banner',{class:_vm.getBannerClass(),style:(_vm.toggleMargin()),attrs:{"environment":_vm.environment}}):_vm._e(),_c('router-view',{class:_vm.showMenu ? 'container' : '',style:(_vm.toggleMargin())}),(_vm.showMenu)?_c('side-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }